const DataLayerDevTools = () => {

    return (
      <div style={{ textAlign: 'left' }}>
          <h1>Browser DevTools: Console</h1>
          <p>This site tracks and stores data in an object assigned to the 'dataLayer' variable.</p>
          <p>Using your browser dev tools console, find the dataLayer object that is stored in memory and paste the value of the first warning message in the text box on the right.</p>
      </div>
    )
  
  }
  
  export default DataLayerDevTools;